import { Descriptions, Flex, Layout, Spin, Table, Typography } from "antd";
import _ from "lodash";
import React from "react";
import { useParams } from "react-router-dom";
import ErrorMessages from "../common/ErrorMessages";
import HeaderScreen from "../common/HeaderScreen";
import ReportButton from "../components/common/ReportButton";
import { SECONDARY_COLOR, WHITE_COLOR } from "../constants/color";
import { URL_REPORT } from "../constants/urls";
import { GET } from "../frameworks/HttpClient";
import { dateTimeToHumanString, dateToHumanString, formatComma } from "../frameworks/Util";

export default function SkimSummaryScreen() {
  const { id } = useParams();
  const [loading, setLoading] = React.useState(false);
  const [errorMessages, setErrorMessages] = React.useState(null);
  const [data, setData] = React.useState(null);

  React.useEffect(() => {
    if(id){
      fetchData();
    }
  },[id])

  const fetchData = async() => {
    setLoading(true);
    setErrorMessages(null);
    try {
      const response = await GET(`${URL_REPORT.SKIM_SUMMARY}${id}/`);
      setData(response.data);
    } catch (error) {
      setErrorMessages(error.errorMessages);
    } finally {
      setLoading(false);
    }
  }
  return (
    <Layout>
      <HeaderScreen title={`รายละเอียดสต๊อกสกิม`} 
        style={{ backgroundColor : SECONDARY_COLOR, 
          color : WHITE_COLOR, 
          fontSize : 18, 
          fontWeight: 'bolder'
        }}
        onClick={() => window.close()}
      />
      <Layout.Content style={{ margin: 24, minHeight: 280, padding: "0px 24px", }}>
        <Spin spinning={loading}>
          <ErrorMessages message={errorMessages}/>
          <Descriptions
            size='small'
            title={
              <Flex justify="space-between">
                ข้อมูลเบื้องต้น
                <ReportButton url={`${URL_REPORT.SKIM_SUMMARY_REPORT}${id}/`}>พิมพ์รายงาน</ReportButton>
              </Flex>
            }
            bordered
            column={1}
            items={[
              { label: 'ล็อต', children: `${data?.lot_no} ${data?.produce_lot_no ? `(${data?.produce_lot_no})` : ''}` },
              { label: 'สินค้า', children: data?.product_name },
              { label: 'วันที่เริ่มผลิต', children: dateTimeToHumanString(data?.created) },
              { label: 'วันที่สิ้นสุดการผลิต', children: dateTimeToHumanString(data?.complete_datetime) },
              { label: 'ปริมาณผลิต (Kg.)', children: formatComma(data?.weight) },
              { label: 'ปริมาณผลิต (ก้อน)', children: formatComma(data?.amount) },
              { label: 'สถานะล็อต', children: data?.is_completed ? "ลงคลังครบจำนวนแล้ว" : "กำลังลงคลัง" },
              { label: 'ผู้ทำรายการเริ่มด้น', children: data?.created_by_name },
          ]}/>
          {/* <Typography.Title level={5}>ผลิตจากการนำเข้า</Typography.Title>
          <Table
            bordered
            pagination={false}
            columns={[
              { title: 'ล็อต', dataIndex: 'lot_no' },
              { title: 'ประเภท', dataIndex: '' },
              { title: 'ปริมาณผลิต', dataIndex: '', render: (value) => formatComma(value) },
              { title: 'หน่วย', dataIndex: ''},
              { title: 'วันที่นำเข้า', dataIndex: '', render: (value) => dateToHumanString(value) },
            ]}
            dataSource={data?.chemical_mix_transaction}/> */}
          <Typography.Title level={5}>ผลิตจากหางยางจากโรงงาน</Typography.Title>
          <Table
            size='small'
            bordered
            pagination={false}
            columns={[
              { title: 'ล็อต', dataIndex: 'lot_no' },
              { title: 'น้ำหนักผลิต', dataIndex: 'current_weight', render: (value) => formatComma(value) },
              { title: 'วันที่เพิ่มล็อตบ่อ', dataIndex: 'created', render: (value) => dateToHumanString(value) },
            ]}
            dataSource={data?.skim_transactions}
            summary={pageData => {
              let total_current_weight = 0;
              pageData.forEach(({ current_weight }) => {
                total_current_weight += Number(current_weight);
              });
              return (
                <>{_.get(data, 'skim_transactions.length', 0) > 0 &&
                  <Table.Summary.Row>
                    <Table.Summary.Cell index={0}>รวม</Table.Summary.Cell>
                    <Table.Summary.Cell index={1}>{total_current_weight}</Table.Summary.Cell>
                    <Table.Summary.Cell index={2}/>
                  </Table.Summary.Row>}
                </>
              );
            }}/>
          <Typography.Title level={5}>ยางที่ผลิตได้</Typography.Title>
          <Table
            size='small'
            bordered
            pagination={false}
            columns={[
              { title: 'วันที่ผลิต', dataIndex: 'created', render: (value) => dateToHumanString(value) },
              { title: 'เลขที่พาเลท', dataIndex: 'stock_no' },
              { title: 'จำนวนก้อน', dataIndex: 'amount', render: (value) => formatComma(value) },
            ]}
            dataSource={data?.skim_stocks}
            summary={pageData => {
              let total_amount = 0;
              pageData.forEach(({ amount }) => {
                total_amount += Number(amount);
              });
              return (
                <>{_.get(data, 'skim_transactions.length', 0) > 0 &&
                  <Table.Summary.Row>
                    <Table.Summary.Cell index={0}>รวม</Table.Summary.Cell>
                    <Table.Summary.Cell index={1}/>
                    <Table.Summary.Cell index={2}>{formatComma(total_amount)}</Table.Summary.Cell>
                  </Table.Summary.Row>}
                </>
              );
            }}/>
          <Typography.Title level={5}>รายการขายสกิม</Typography.Title>
          <Table
            size='small'
            bordered
            pagination={false}
            columns={[
              { title: 'ชื่อลูกค้า', dataIndex: 'buyer_name' },
              { title: 'IRL Contract No.', dataIndex: 'irl_no' },
              { title: 'วันที่ส่งสินค้า', dataIndex: 'date', render : (value) => dateToHumanString(value) },
              { title: 'SERIALID', dataIndex: 'serial_id' },
              { title: 'SERIALNO', dataIndex: 'serial_no' },
              { title: 'ปริมาณสั่งซื้อ', dataIndex: 'net_weight', render: (value) => formatComma(value) },
            ]}
            dataSource={data?.deliver_orders}
            summary={pageData => {
              let total_net_weight = 0;
              pageData.forEach(({ net_weight }) => {
                total_net_weight += Number(net_weight);
              });
              return (
                <>{_.get(data, 'deliver_orders.length', 0) > 0 &&
                  <Table.Summary.Row>
                    <Table.Summary.Cell index={0}>รวม</Table.Summary.Cell>
                    <Table.Summary.Cell index={1}/>
                    <Table.Summary.Cell index={2}/>
                    <Table.Summary.Cell index={3}/>
                    <Table.Summary.Cell index={4}/>
                    <Table.Summary.Cell index={5}>{formatComma(total_net_weight)}</Table.Summary.Cell>
                  </Table.Summary.Row>}
                </>
              );
            }}/>
        </Spin>
      </Layout.Content>
    </Layout>
  )
}